import GetStores from './GetStores'

export default GetStores
